import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlus16 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.75 7.875H10.125V2.25H7.875V7.875H2.25V10.125H7.875V15.75H10.125V10.125H15.75V7.875Z",
		fill: "white"
	})
});
export default SvgPlus16;
